import React from 'react';
import ProjectContent from '../components/ProjectContent';

const YelpDecisionMaker = () => <ProjectContent projectName='Yelp Decision Maker'/>;

export default YelpDecisionMaker;